export default {
    methods: {
        createMeta({ title, description, ogImage, canonical }) {
            const metaInfo = {
                title,
                meta: [],
                link: [],
            };
            if (title) {
                metaInfo.meta.push(
                    {
                      name: 'twitter:card',
                      vmid: 'twitter:card',
                      content: 'summary_large_image',
                    },
                    {
                        name: "og:title",
                        vmid: "og:title",
                        content: title,
                    },
                    {
                        name: "twitter:title",
                        vmid: "twitter:title",
                        content: title,
                    },
                    {
                        name: "title",
                        vmid: "title",
                        content: title,
                    },
                    { vmid: 'twitter:site', name: 'twitter:site', content: '@Classino' },
                );
            }
            if (description) {
                metaInfo.meta.push(
                    {
                        name: "description",
                        vmid: "description",
                        content: description,
                    },
                    {
                        name: "og:description",
                        vmid: "og:description",
                        content: description,
                    },
                    {
                        name: "twitter:description",
                        vmid: "twitter:description",
                        content: description,
                    }
                );
            }
            if(ogImage){
                metaInfo.meta.push(
                  { vmid: 'og:image', name: 'og:image', content: ogImage },
                );
            }
            if (canonical) {
                metaInfo.link.push({
                    rel: "canonical",
                    vmid: "canonical",
                    href: import.meta.env.VIT_APP_BASE_URL_CANONICAL || 'https://www.classsino.com' + canonical ,
                });
            }
            return metaInfo;
        },
    },
};
